import styled from 'styled-components';

export const TwoSideToggleStyles = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.25rem;
	padding: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.gray[0]};

	.switch {
		width: 100%;
	}
`;
